import React, { Component } from 'react'
import {
  MDBBreadcrumb,
  MDBBreadcrumbItem,
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBContainer,
  MDBInput,
  MDBRow,
  MDBCol,
} from 'mdb-react-ui-kit'
import DashboardLayout from '../../components/Admin/DashboardLayout'
import WebsiteContentService from '../../shared/services/WebsiteContent.service'
import TextEditor from '../../components/shared/TextEditor/TextEditor.component'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'

class WebsiteContentEdit extends Component {
  state = {
    saving: false,
    loading: false,
    isEdit: false,
    slug: '',
    page_name: '',
    content_type: 'page_config',
    title: '',
    content: '',
    content_data: '',
    active: 1,
    jsonError: null,
  }

  componentDidMount() {
    const {
      match: { params },
    } = this.props
    if (params && params.id) {
      this.setState({ isEdit: true })
      this.fetchData(params.id)
    }
  }

  fetchData = async id => {
    this.setState({ loading: true })
    try {
      const result = await WebsiteContentService.get(id)
      if (result) {
        const data = result
        let contentDataStr = ''
        if (data.content_data) {
          try {
            contentDataStr =
              typeof data.content_data === 'string'
                ? JSON.stringify(JSON.parse(data.content_data), null, 2)
                : JSON.stringify(data.content_data, null, 2)
          } catch (e) {
            contentDataStr =
              typeof data.content_data === 'string' ? data.content_data : JSON.stringify(data.content_data)
          }
        }

        this.setState({
          slug: data.slug || '',
          page_name: data.page_name || '',
          content_type: data.content_type || '',
          title: data.title || '',
          content: data.content || '',
          content_data: contentDataStr,
          active: data.active != null ? data.active : 1,
        })
      }
    } catch (error) {
      toast.error('Failed to load content.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      this.setState({ loading: false })
    }
  }

  validateJson = str => {
    if (!str || !str.trim()) return true
    try {
      JSON.parse(str)
      return true
    } catch (e) {
      return false
    }
  }

  prettyPrintJson = () => {
    const { content_data } = this.state
    if (!content_data || !content_data.trim()) return
    try {
      const parsed = JSON.parse(content_data)
      this.setState({
        content_data: JSON.stringify(parsed, null, 2),
        jsonError: null,
      })
    } catch (e) {
      this.setState({ jsonError: 'Invalid JSON: ' + e.message })
    }
  }

  save = async () => {
    const { saving, isEdit, slug, page_name, content_type, title, content, content_data, active } = this.state
    if (saving) return

    if (!slug || !slug.trim()) {
      toast.error('Slug is required.', { position: toast.POSITION.TOP_RIGHT })
      return
    }

    if (content_data && content_data.trim() && !this.validateJson(content_data)) {
      toast.error('content_data must be valid JSON.', {
        position: toast.POSITION.TOP_RIGHT,
      })
      return
    }

    this.setState({ saving: true })

    const payload = {
      slug: slug.trim(),
      page_name: page_name.trim(),
      content_type: content_type.trim(),
      title: title.trim(),
      content: content,
      content_data: content_data && content_data.trim() ? content_data.trim() : null,
      active: active ? 1 : 0,
    }

    try {
      if (isEdit) {
        const id = this.props.match.params.id
        await WebsiteContentService.update(id, payload)
        toast.success('Content updated successfully.', {
          position: toast.POSITION.TOP_RIGHT,
        })
      } else {
        await WebsiteContentService.store(payload)
        toast.success('Content created successfully.', {
          position: toast.POSITION.TOP_RIGHT,
        })
        this.props.history.push('/admin-website-content')
      }
    } catch (error) {
      toast.error('Failed to save content.', {
        position: toast.POSITION.TOP_RIGHT,
      })
    } finally {
      this.setState({ saving: false })
    }
  }

  render() {
    const { isEdit, loading, saving, slug, page_name, content_type, title, content, content_data, active, jsonError } =
      this.state

    const goBack = () => this.props.history.goBack()

    if (loading) {
      return (
        <DashboardLayout>
          <main className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <h4>Loading...</h4>
            </MDBContainer>
          </main>
        </DashboardLayout>
      )
    }

    return (
      <DashboardLayout>
        <main className='mainSection'>
          <MDBContainer fluid className='mt-5'>
            <h2>
              {isEdit ? 'Edit Website Content' : 'Create Website Content'}
              <div className='float-right'>
                <MDBBtn type='button' color='danger' rounded size='sm' onClick={goBack}>
                  Cancel
                </MDBBtn>
              </div>
            </h2>

            {isEdit && (
              <MDBBreadcrumb>
                <MDBBreadcrumbItem>
                  <a href='/admin-website-content'>Website Content</a>
                </MDBBreadcrumbItem>
                <MDBBreadcrumbItem active>Editing &quot;{slug}&quot;</MDBBreadcrumbItem>
              </MDBBreadcrumb>
            )}

            <MDBCard>
              <MDBCardBody>
                <MDBRow>
                  <MDBCol md='6'>
                    <label className='font-weight-bold'>Slug *</label>
                    <input
                      type='text'
                      className='form-control mb-3'
                      value={slug}
                      onChange={e => this.setState({ slug: e.target.value })}
                      placeholder='e.g. health_insurance_page'
                    />
                  </MDBCol>
                  <MDBCol md='6'>
                    <label className='font-weight-bold'>Page Name</label>
                    <input
                      type='text'
                      className='form-control mb-3'
                      value={page_name}
                      onChange={e => this.setState({ page_name: e.target.value })}
                      placeholder='e.g. Insurance Plans'
                    />
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md='4'>
                    <label className='font-weight-bold'>Content Type</label>
                    <select
                      className='form-control mb-3'
                      value={content_type}
                      onChange={e => this.setState({ content_type: e.target.value })}
                    >
                      <option value='page_config'>page_config</option>
                      <option value='section'>section</option>
                      <option value='component'>component</option>
                      <option value='snippet'>snippet</option>
                    </select>
                  </MDBCol>
                  <MDBCol md='6'>
                    <label className='font-weight-bold'>Title</label>
                    <input
                      type='text'
                      className='form-control mb-3'
                      value={title}
                      onChange={e => this.setState({ title: e.target.value })}
                    />
                  </MDBCol>
                  <MDBCol md='2'>
                    <label className='font-weight-bold'>Active</label>
                    <div className='custom-control custom-switch mt-2'>
                      <input
                        type='checkbox'
                        className='custom-control-input'
                        id='activeSwitch'
                        checked={!!active}
                        onChange={e => this.setState({ active: e.target.checked ? 1 : 0 })}
                      />
                      <label className='custom-control-label' htmlFor='activeSwitch'>
                        {active ? 'Active' : 'Inactive'}
                      </label>
                    </div>
                  </MDBCol>
                </MDBRow>

                <hr />

                <label className='font-weight-bold'>Content (Rich Text)</label>
                <TextEditor
                  id='website-content-editor'
                  value={content}
                  onChange={html => this.setState({ content: html })}
                />

                <hr />

                <label className='font-weight-bold'>
                  Structured Data (JSON)
                  <MDBBtn type='button' size='sm' color='info' className='ml-2' onClick={this.prettyPrintJson}>
                    Format JSON
                  </MDBBtn>
                </label>
                {jsonError && (
                  <div className='text-danger mb-2' style={{ fontSize: '0.85rem' }}>
                    {jsonError}
                  </div>
                )}
                <textarea
                  className='form-control mb-3'
                  rows='12'
                  value={content_data}
                  onChange={e =>
                    this.setState({
                      content_data: e.target.value,
                      jsonError: null,
                    })
                  }
                  placeholder='{"key": "value"}'
                  style={{ fontFamily: 'monospace', fontSize: '0.85rem' }}
                />

                <MDBBtn type='button' color='unique' onClick={this.save}>
                  {saving ? 'Saving...' : 'Save'}
                </MDBBtn>
              </MDBCardBody>
            </MDBCard>
          </MDBContainer>
        </main>
      </DashboardLayout>
    )
  }
}

export default withRouter(WebsiteContentEdit)
